export class SweftError extends Error {
    constructor(message) {
        super(message);
        this.name = "SweftError";
    }
}
